<template>
  <div class="button-bd" :class="[{'fixed':fixed},{'radius':radius}]" @click='onChange'>
    <p :class="[{'disabled': disabled },{'small': size === 'small'}]">
      <slot>{{text}}</slot>
    </p>
  </div>
</template>
<script>
/**
   * @param text [String] 按钮显示文字
   * @param size [String] 按钮大小类型,default/small
   * @param disabled [String] 按钮是否可点击
   * @param fixed [String] 按钮是否固定在底部
   * @param radius [String] 按钮是否有圆角
   * @param change [Function] 按钮点击事件
   * @describe disabled属性可以阻止触发chang事件，如果按钮事件非change触发则无效仅样式显示
   *
   * @example
   *
    <t-button fixed disabled text='提交'></t-button>
   */

export default {
  name: 'tButton',
  props: {
    size: {
      type: String,
      default: '',
    },
    text: { // 按钮文字
      type: String,
      default: '按钮',
    },
    disabled: { // 是否可点击
      default: false,
    },
    fixed: { // 是否固定在底部
      type: Boolean,
      default: false,
    },
    radius: { // 是否有边框弧度
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onChange: function () {
      if (this.disabled) return;
      this.$emit('change');
    },
  },
};

</script>
<style lang="scss">
.button-bd {
  &.fixed {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 4;
    p {
      height: 50px;
      line-height: 50px;
    }
  }
  &.radius {
    border-radius: 3px;
    overflow: hidden;
  }
  p {
    height: 44px;
    line-height: 44px;
    text-align: center;
    color: #FFFFFF;
    font-size: 16px;
    background: #f4b357;
    &.disabled {
      background: #aaa;
    }
    &.small {
      height: 36px;
      line-height: 36px;
      font-size: 15px;
      padding: 0 20px;
      border-radius: 2px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/button.vue